import Axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Row } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import { goRiceUrl } from '../../../constant/siteConstants';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import getConfigToken from '../../../utils/getConfigToken';
import useFormatMessage from '../../../utils/useFormatMessage';
import AddModal from '../components/YetkiGrupYonetimi/AddModal';
import PermissionTable from '../components/YetkiGrupYonetimi/PermissionTable';

export default function YetkiGrupYonetimi() {
    const { t } = useFormatMessage();
    const notifyError = (message) => toast.error(`${message}`);
    const [modalNew, setModalNew] = useState(false);
    const [permissionGroupDatas, setPermissionGroupDatas] = useState([]);
    const [triger, setTriger] = useState(false)

    async function getPermissionGroupDatas() {
        await Axios.post(`${goRiceUrl}/api/employee/getPermissionGroupsWithRoles`, {}, getConfigToken).then((resp) => {
            setPermissionGroupDatas(resp.data.permission_groups || []);
        }).catch((err) => {
            console.error(err);
            notifyError("Yetki Grupları yüklenirken bir servis hatası meydana geldi.");
        })
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        getPermissionGroupDatas();
    }, [triger])
    /* eslint-disable react-hooks/exhaustive-deps */

    const dataGridRef = useRef();

    return (
        <>
            <Breadcrumb parent={`Edgemon`} parentPath={`/index`} current={t("Yetki Grup Yönetimi")} />
            <div className='card mb-4 p-4'>
                <Row className='mb-3'>
                    <Col xl="12" className='d-flex justify-content-end' style={{ gap: "5px" }}>
                        <Button onClick={() => setModalNew(true)}>{t("Yetki Grubu Oluştur")}</Button>
                        <Button className='btn-success' style={{ padding: "6px 10px", cursor: "pointer" }} onClick={(e) => { ButtonOnExporting(e, dataGridRef, `Yetki Grup Yönetimi ${moment(new Date()).format("DD/MM/YYYY")}`, "Revizyon 1") }}>
                            <i className='fa fa-file-excel-o' style={{ color: "white" }}></i>
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xl="12">
                        <PermissionTable dataGridRef={dataGridRef} dataSource={permissionGroupDatas} setTriger={setTriger} triger={triger} />
                        <AddModal modalNew={modalNew} setModalNew={setModalNew} setTriger={setTriger} triger={triger} />
                    </Col>
                </Row>
            </div>
        </>
    )
}